import { rest } from 'msw';
import { API_REST_URL } from 'config/variables';

import { lpMock } from '../larningPaths.mock';

const getUserLearningPath = rest.get(
  `${API_REST_URL}/learning-paths/user/:clientId/:lpId/:userId`,
  (req, res, ctx) => {
    return res(ctx.json(lpMock));
  },
);

export const learningPathsHandlers = [getUserLearningPath];
